<template>
  <div class="m-wap-content" v-html="content"></div>
</template>
<script>
import { $subscriber } from "fire-wind-water";
export default {
  name: "Content",
  data() {
    return {
      content: "",
      title: "",
      pushTime: "",
      likeCount: "",
      browseCount: "",
      commentCount: "",
      isAllowedComment: "",
      isAllowedLike: false,
      //      isAllowedLike: true,
      //      likeCount: 0,
      canLike: false,
      schemaId: "",
      isSubmitting: false
    };
  },
  created() {
    $subscriber.subscribe("article-info", info => {
      if (info) {
        this.content = info.content;
        this.title = info.title;
        this.pushTime = info.pushTime;
        this.likeCount = info.likeCount;
        this.browseCount = info.statInfo.browseCount;
        this.isAllowedComment = info.isAllowedComment == 1;
        this.isAllowedLike = info.isAllowedLike == 1;
      }
      $subscriber.subscribe("comment-count", info => {
        this.commentCount = info;
      });
      $subscriber.subscribe("like-count", info => {
        this.likeCount = info;
      });
    });
  },
  components: {}
};
</script>
